import { render, staticRenderFns } from "./QuestionsItem.vue?vue&type=template&id=8282e1c4&scoped=true"
import script from "./QuestionsItem.vue?vue&type=script&lang=js"
export * from "./QuestionsItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionsItem.vue?vue&type=style&index=0&id=8282e1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8282e1c4",
  null
  
)

export default component.exports